export const computeTotalRow = (
        data,
        totalLabel = 'Total Cost',
        keyField = 'DESC',
        excludeKeys = ['DESC', 'key'],
        sumFromFormatted = false,   // 🆕 opt-in flag
) => {
        if (!data.length) return {};

        const numericKeys = Array.from(
                new Set(
                        data.flatMap(row =>
                                Object.keys(row).filter(key => !excludeKeys.includes(key))
                        )
                )
        );

        const totalRow = { key: 'total', [keyField]: totalLabel, boldHeading: true };

        numericKeys.forEach((key) => {
                if (key.endsWith('_formatted')) return;

                const formattedKey = `${key}_formatted`;
                const isFinancialYear = data.some((row) => row.hasOwnProperty(formattedKey));

                if (isFinancialYear) {
                        let sum = 0;
                        data.forEach((row) => {
                                // 🆕 conditional source: formatted (correct scale) vs raw (legacy behavior)
                                let value = sumFromFormatted ? row[formattedKey] : row[key];
                                if (typeof value === 'string') {
                                        value = value.replace(/,/g, '');
                                }
                                const num = Number(value);
                                if (!isNaN(num)) {
                                        sum += num;
                                }
                        });
                        totalRow[formattedKey] = formatIndianNumber(sum.toFixed(2));
                } else {
                        let sum = 0;
                        data.forEach((row) => {
                                let value = row[key];
                                if (typeof value === 'string') {
                                        value = value.replace(/,/g, '');
                                }
                                const num = Number(value);
                                if (!isNaN(num)) {
                                        sum += num;
                                }
                        });
                        totalRow[key] = formatIndianNumber(sum.toFixed(2));
                }
        });

        return totalRow;
};

export const computeTotalRowProfit = (
        data,
        totalLabel = 'Total Cost',
        keyField = 'DESC',
        excludeKeys = ['DESC', 'key'],
        filterName = '',
        sumFromFormatted = false,
) => {
        if (!data.length) return {};

        // ✅ Filter rows with DESCRIPTION === 'Total Profit (A-B)'
        const filteredData = data.filter((row) => row.DESCRIPTION === filterName);
        if (!filteredData.length) return {};

        const rowWithMaxKeys = filteredData.reduce((maxRow, currentRow) => {
                return Object.keys(currentRow).length > Object.keys(maxRow).length
                        ? currentRow
                        : maxRow;
        }, filteredData[0]);

        // const numericKeys = Object.keys(rowWithMaxKeys).filter((key) => !excludeKeys.includes(key));
        const numericKeys = Array.from(
                new Set(
                        filteredData.flatMap(row =>
                                Object.keys(row).filter(key => !excludeKeys.includes(key))
                        )
                )
        );

        const totalRow = {
                key: 'total',
                [keyField]: totalLabel,
                boldHeading: true,
                DESCRIPTION: filterName,
        };

        numericKeys.forEach((key) => {
                if (key.endsWith('_formatted')) return;

                const formattedKey = `${key}_formatted`;
                const isFinancialYear = filteredData.some((row) =>
                        row.hasOwnProperty(formattedKey),
                );

                // if (isFinancialYear) {
                //         const formattedValue =
                //                 filteredData.find((row) => row[key])?.[key] ?? '0.00';

                //         let sum = 0;
                //         filteredData.forEach((row) => {
                //                 let value = row[key];
                //                 if (typeof value === 'string') {
                //                         value = value.replace(/,/g, '');
                //                 }
                //                 const num = Number(value);
                //                 if (!isNaN(num)) {
                //                         sum += num;
                //                 }
                //         });

                //         totalRow[formattedKey] = formatIndianNumber(sum);
                // }

                if (isFinancialYear) {
                        let sum = 0;
                        filteredData.forEach((row) => {
                                let value = sumFromFormatted ? row[formattedKey] : row[key]; // 🆕
                                if (typeof value === 'string') {
                                        value = value.replace(/,/g, '');
                                }
                                const num = Number(value);
                                if (!isNaN(num)) {
                                        sum += num;
                                }
                        });
                        totalRow[formattedKey] = formatIndianNumber(sum.toFixed(2));
                } else {
                        let sum = 0;
                        filteredData.forEach((row) => {
                                let value = row[key];
                                if (typeof value === 'string') {
                                        value = value.replace(/,/g, '');
                                }
                                const num = Number(value);
                                if (!isNaN(num)) {
                                        sum += num;
                                }
                        });

                        totalRow[key] = formatIndianNumber(sum.toFixed(2));
                }
        });

        return totalRow;
};


export const computeTotalGrossBillingRow = (
        data,
        totalLabel = 'Total Cost',
        billingCostCompleteData,
        keyField = 'DESC',
        excludeKeys = ['DESC', 'key'],
) => {
        if (!data.length) return {};

        const filteredData = data.filter((row) => row.ADD_PACKAGE_STATUS === 1);
        // const filteredData = data.filter(
        //         (row) =>
        //                 row.ADD_PACKAGE_STATUS === 1 ||
        //                 Object.keys(row).some(key => /^[A-Z][a-z]{2}_\d{2}$/.test(key))
        // );

        // ✅ Get the row with the maximum number of keys
        const rowWithMaxKeys = data.reduce((maxRow, currentRow) => {
                return Object.keys(currentRow).length > Object.keys(maxRow).length
                        ? currentRow
                        : maxRow;
        }, data[0]);

        // ✅ Derive numeric keys dynamically
        // const numericKeys = Object.keys(rowWithMaxKeys).filter((key) => !excludeKeys.includes(key));
        const numericKeys = Array.from(
                new Set(
                        data.flatMap(row =>
                                Object.keys(row).filter(key => !excludeKeys.includes(key))
                        )
                )
        );

        const totalRow = { key: 'total', [keyField]: totalLabel, boldHeading: true };
        const discrepancyKeys = [];

        numericKeys.forEach((key) => {
                let sum = 0;

                if (['BILLED_BALANCE', 'BILLED_UPTO', 'TCR'].includes(key)) {
                        let value = 0;
                        filteredData.forEach((row) => {
                                let rowValue = row[key];
                                if (typeof rowValue === 'string') {
                                        rowValue = rowValue.replace(/,/g, '');
                                }

                                const num = Number(rowValue);
                                if (!isNaN(num)) {
                                        value += num;
                                }
                        });

                        const billedRaw = billingCostCompleteData?.[key];
                        const billedNum =
                                parseFloat(
                                        typeof billedRaw === 'string'
                                                ? billedRaw.replace(/,/g, '')
                                                : billedRaw,
                                ) || 0;

                        totalRow[key] = formatIndianNumber(billedNum.toFixed(2));

                        if (billedRaw && billedNum.toFixed(2) !== value.toFixed(2)) {
                                totalRow[key + '_discrepancy'] = true;
                                discrepancyKeys.push(key);
                        }
                } else {
                        filteredData.forEach((row) => {
                                let value = row[key];
                                if (typeof value === 'string') {
                                        value = value.replace(/,/g, '');
                                }

                                const num = Number(value);
                                if (!isNaN(num)) {
                                        sum += num;
                                }
                        });

                        totalRow[key] = formatIndianNumber(sum.toFixed(2));
                }
        });

        return totalRow;
};

export const computeCashNetFlow = (inflowRow, outflowRow) => {
        const netFlow = {
                DESC: 'Cash Net Flow',
                boldHeading: true,
        };

        const keys = Object.keys(inflowRow).filter(
                (key) => key !== 'DESC' && key !== 'boldHeading',
        );

        keys.forEach((key) => {
                const inflow = parseFloat(inflowRow[key]?.toString().replace(/,/g, '')) || '0.00';
                const outflow = parseFloat(outflowRow[key]?.toString().replace(/,/g, '')) || '0.00';
                const result = inflow - outflow;

                netFlow[key] = formatIndianNumber(result.toFixed(2)); // format with commas
        });

        return netFlow;
};

export const formatIndianNumber = (numStr) => {
        const num = parseFloat(numStr);
        if (isNaN(num)) return numStr;

        const fixed = num.toFixed(2); // Ensures two decimal places

        let [integerPart, decimalPart] = fixed.split('.');
        // Handle negative numbers separately
        const isNegative = integerPart.startsWith('-');
        if (isNegative) {
                integerPart = integerPart.slice(1); // Remove '-' temporarily
        }

        let lastThree = integerPart.slice(-3);
        let otherDigits = integerPart.slice(0, -3);

        if (otherDigits !== '') {
                lastThree = ',' + lastThree;
        }

        const formattedInteger = otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree;
        return `${isNegative ? '-' : ''}${formattedInteger}.${decimalPart}`;
};
